export default __webpack_public_path__ + "static/media/SleepBackground.e031c17d.png";